import useMsalUser from '@shared/hooks/useMsalUser';
import appLogger, { EventDetail } from '@shared/logging/appLogger';
import LoggerTypes from '@shared/types/logger';
import { useCallback, useEffect } from 'react';

function AdobeAnalyticsListener() {
    const { getUser } = useMsalUser();
    const pushAdobeDataLayer = event => {
        const { adobeDataLayer } = window;
        if (!adobeDataLayer) return;

        try {
            adobeDataLayer.push(event);
        } catch (error) {
            if (error instanceof Error) {
                console.error(error);
                appLogger.logException({
                    error,
                });
            } else {
                console.error(error);
            }
        }
    };
    const LogAdobeEvent = useCallback(
        (event: CustomEvent<EventDetail>) => {
            if (event.detail.ignoreAdobeAnalytics) return;

            const userId = getUser()?.consumerResourceId;
            const uri =
                typeof event.detail.properties?.location === 'string'
                    ? (event.detail.properties?.location as string)
                    : '';
            const queryString =
                uri.indexOf('?') == -1 ? '' : uri.substring(uri.indexOf('?'), uri.length);
            const baseUri = uri.substring(
                0,
                uri.indexOf('?') == -1 ? uri.length : uri.indexOf('?')
            );
            const refUri = document.referrer;
            const timestamp = new Date(Date.now());

            const adobeAnalyticsEvent = {
                // rule name
                event: event.detail.properties?.ruleName || event.detail.name,
                // Prepopulated items
                userId,
                uri: baseUri,
                refUri,
                queryString,
                timestamp: timestamp.toLocaleString('en-US'),
                screenSize: `${window.screen.width}x${window.screen.height}`,
                server: window.location.hostname,
                // override values
                concatValue: event.detail.properties?.concatValue
                    ? event.detail.properties?.concatValue
                    : `${event.detail.properties?.linkOriginatingPageName} | ${event.detail.properties?.linkText} | ${event.detail.properties?.linkPosition}`,
                siteSection:
                    event.detail.properties?.siteSection ||
                    event.detail.properties?.linkOriginatingPageName ||
                    event.detail.name,
                channel:
                    event.detail.properties?.channel ||
                    event.detail?.properties?.linkOriginatingPageName ||
                    event.detail.name,
                pageName: event.detail.properties?.linkOriginatingPageName || event.detail.name,
                // Other Items
                ...event.detail.properties,
            };

            pushAdobeDataLayer(adobeAnalyticsEvent);
        },
        [getUser]
    );

    useEffect(() => {
        window.addEventListener(LoggerTypes.PAGE_VIEW, LogAdobeEvent);
        window.addEventListener(LoggerTypes.EVENT, LogAdobeEvent);
        return () => {
            window.removeEventListener(LoggerTypes.PAGE_VIEW, LogAdobeEvent);
            window.removeEventListener(LoggerTypes.EVENT, LogAdobeEvent);
        };
    }, [LogAdobeEvent]);
    return <></>;
}

export default AdobeAnalyticsListener;
